import { Component } from '@angular/core';
import { TurnosAsignarComponent } from '../asignar-turno/asignar-turno.component';
import { MatDialog } from '@angular/material/dialog';
import { Shift } from 'app/models/shift.models';
import { ShiftsService } from 'app/services/shifts.service';
import { OperatorshiftsService } from 'app/services/operatorshifts.service';
import { OperatorShifts } from 'app/models/operator-shifts.models';
import { Usuario } from 'app/models/usuario';
import { AuthService } from 'app/services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-turnos',
  templateUrl: './turnos.component.html',
  styleUrls: ['./turnos.component.css'],
})
export class TurnosComponent {
  turnos: OperatorShifts[] = [];
  operadores: Usuario[] = [];
  shifts: [] = [];

  constructor(
    public dialog: MatDialog,
    private operatorshiftService: OperatorshiftsService,
    private authService: AuthService,
    private shiftsService: ShiftsService,
    private _snackBar: MatSnackBar
  ) {
    this.getTurnosAsignados();
    this.getUsuarios();
    this.getTurnos();
  }

  abrirDialogo() {
    const dialogRef = this.dialog.open(TurnosAsignarComponent, {
      width: '35%',
      data: {
        operadores: this.operadores,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getTurnosAsignados();
      }
    });
  }

  getTurnos() {
    this.shiftsService.getTurnos().subscribe(
      (data: any) => {
        this.shifts = data;
      },
      error => {
        console.error(error);
      }
    );
  }

  getUsuarios() {
    this.authService.getUsuarios().subscribe(
      (data: any) => {
        this.operadores = data.users;
      },
      error => {
        console.error(error);
      }
    );
  }

  getTurnosAsignados() {
    this.operatorshiftService.getTurnosOperadores().subscribe(
      (data: any) => {
        this.turnos = data;
      },
      error => {
        console.error(error);
      }
    );
  }

  editarTurno(turno: Shift) {
    const dialogRef = this.dialog.open(TurnosAsignarComponent, {
      width: '35%',
      data: {
        operadores: this.operadores,
        turnoSeleccionado: turno.shiftId,
        operadorSeleccionado: turno.userId || turno.operatorId
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.operatorshiftService
          .updateTurnoOperador(turno.id, { 
            shiftId: result.shiftId,
            operatorId: result.operatorId 
          })
          .subscribe({
            next: res => {
              import('sweetalert2').then(Swal => {
                Swal.default.fire({
                  title: 'Operación exitosa',
                  text: 'Se ha actualizado la asignación del operador al turno correctamente',
                  icon: 'success',
                  confirmButtonText: 'Aceptar'
                });
              });
              this.getTurnosAsignados();
              this.getTurnos();
            },
            error: err => {
              console.log({ err });
              this.openSnackBar(`Ocurrió un error al editar el turno`, 'Error');
            },
          });
      }
    });
  }

  eliminarTurno(turno: any) {
    Swal.fire({
      title: 'Advertencia',
      text: '¿Seguro que desea eliminar el turno?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
    }).then(result => {
      if (result.value) {
        this.operatorshiftService.deleteTurnoOperador(turno.id).subscribe(
          (data: any) => {
            console.log(data);
            this.openSnackBar(`Turno eliminado correctamente.`, 'Información');
            this.getTurnosAsignados();
          },
          error => {
            console.error({ error });
            this.openSnackBar(`Ocurrió un error al eliminar el turno`, 'Error');
          }
        );
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
}
